import '../../shared/error-boundary.ts';
/**
 * Tool page entry — data-base64-decode
 */

import { base64Decode } from '@bytario/core/data/base64-decode';
import { downloadBytes } from '../../shared/download.ts';
import { createProgress, yieldToPaint } from '../../shared/progress.ts';

function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  })[c]!);
}

function formatBytes(n: number): string {
  if (n < 1024) return n + ' B';
  if (n < 1024 * 1024) return (n / 1024).toFixed(1) + ' KB';
  return (n / (1024 * 1024)).toFixed(2) + ' MB';
}

function isText(bytes: Uint8Array): boolean {
  for (let i = 0; i < Math.min(bytes.length, 8192); i++) {
    const b = bytes[i]!;
    if (b < 0x09 || (b > 0x0d && b < 0x20 && b !== 0x1b)) return false;
  }
  try { new TextDecoder('utf-8', { fatal: true }).decode(bytes); return true; } catch { return false; }
}

const button = document.querySelector('#run') as HTMLButtonElement;
button.addEventListener('click', async () => {
  const input = (document.querySelector('#text') as HTMLTextAreaElement).value.trim();
  if (!input) return;
  const p = createProgress('#result', ['Decoding', 'Complete']);
  try {
    p.activate(0);
    await yieldToPaint();
    const decoded = await base64Decode(new TextEncoder().encode(input));
    const bytes = decoded instanceof Uint8Array ? decoded : new TextEncoder().encode(decoded as string);
    p.complete(0);

    p.activate(1);
    p.complete(1);
    if (isText(bytes)) {
      const text = new TextDecoder().decode(bytes);
      p.finish('<p><strong>Detected:</strong> UTF-8 text (' + formatBytes(bytes.length) + ')</p><pre class="wrap">' + escapeHtml(text) + '</pre>');
    } else {
      downloadBytes(bytes, 'decoded.bin', 'application/octet-stream');
      p.finish('<p><strong>Detected:</strong> Binary data (' + formatBytes(bytes.length) + ') — download started.</p>');
    }
  } catch (e) {
    p.error(String(e));
  }
});
